import { render, staticRenderFns } from "./myPublish.vue?vue&type=template&id=38b7da70&"
import script from "./myPublish.vue?vue&type=script&lang=js&"
export * from "./myPublish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports